import React from 'react';
import { Modal, Input, message, Spin, Radio, Select, InputNumber } from 'antd';
import { getMatchOption } from '../../shared/selectFn';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import format from '../../shared/format';
import Text from '../../basicElement/Text';

const RadioGroup = Radio.Group;
const { Option } = Select;


class ApproveDeliverCode extends React.Component {
    state = {
        visible: false,
        investigation: {},
        saveParams: {},
        loading: true,
        record: {},
        fileList: [],
        contractTypeList: [],
        currencyList: [],
        belongingToUnitList: [],
        criterion:[],
        allTrue: true,
        isClear: true,
        markRed: false,
        rebateAmount: '',
    }

    show = record => {
        const {
			autoLoadJdeInfo,
            lineOfBusiness,
            secondLineIds,
            unitOfSigningId,
            unitOfBelongingId,
            belongingToUnit,
            exchangeRate,
            currencyName,
            dateShow,
            currencyCode,
            currencyExchangeRateId,
            currencyExchangeRate,
            expectContractAmount,
            contractAmount,
            actualExpenseFee,
            actualFee,
            taxationFee,
            initialExpectContractAmount,
            initialContractAmount,
            initialActualExpenseFee,
            initialActualFee,
            initialTaxationFee,
            investigationId,
        } = record;
        const contractParams = {};
        if (currencyCode !== 'CNY') {
            contractParams.expectContractAmount = initialExpectContractAmount;
            contractParams.contractAmount = initialContractAmount;
            contractParams.actualExpenseFee = initialActualExpenseFee;
            contractParams.actualFee = initialActualFee;
            contractParams.taxationFee = initialTaxationFee;
        } else {
            contractParams.expectContractAmount = expectContractAmount;
            contractParams.contractAmount = contractAmount;
            contractParams.actualExpenseFee = actualExpenseFee;
            contractParams.actualFee = actualFee;
            contractParams.taxationFee = taxationFee;
        }
        const { signingUnitList } = this.props;
        const belongingToUnitList = (signingUnitList.find(i => i.unitOfSigningId == unitOfSigningId) || {}).belongings || [];
        this.setState({
            record,
            visible: true,
            saveParams: {
				autoLoadJdeInfo,
                lineOfBusiness,
                secondLineIds,
                signingUnit: unitOfSigningId,
                belongingToUnit: unitOfBelongingId,
                belongingToUnitName: belongingToUnit,
                exchangeRate,
                currencyName,
                dateShow,
                currencyExchangeRate,
                currencyExchangeRateId,
                ...contractParams,
            },
            belongingToUnitList,
            criterion:[
                {
                    key: 'amount',
                    context:'关联合同扣除金额后，该合同剩余的合同额含税/原币<该合同“发票金额（含税）总金额或外币应税额”合计值',
                    processed: false,
                },{
                    key: 'custom',
                    context:'同JDE项目号下客户名称不一致，是否继续发号？',
                    processed: false,
                    noPassReason: '同JDE项目号下客户名称不一致，请调整客户信息或给新客户新建JDE号',
                },{
                    key: 'specifiesAmount',
                    context:'该JDE项目号有误或申请调整金额有误',
                    processed: false,
                    noPassReason: '累计明标合同金额或实报实销金额＜0，请调整合同额',
                    refuseReason: '重复提交',
                },{
                    key: 'noSpecifiesAmount',
                    context:'该JDE项目号有误或申请调整金额有误',
                    processed: false,
                    noPassReason: '累计非明标合同金额或实报实销金额＜0，请调整合同额',
                    refuseReason: '重复提交',
                },{
                    key: 'checkDate',
                    context:'同JDE项目号下合同开始时间、合同结束时间不一致，请修改',
                    processed: false,
                    noPassReason: '同JDE项目号下合同开始时间、合同结束时间不一致，请修改',
                },
            ],
        }, () => {
            record && this.loadData();
            this.loadAllCurrencyExchangeRateList();
            if (record.contractOrLetterIsSign == '1') {
                this.loadTypeConfigureList();
                this.loadFileList();
            }
            if (sessionStorage.curRole === 'FIN') {
                this.queryInvestigationStageByInvId(investigationId);
            }
        });
    }

    queryInvestigationStageByInvId = (investigationId) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const markRed = (data || []).some(el => el.operation === 'BUSINESS_DATA_ARCHIVING');
                this.setState({ markRed });
            },
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            fileList: [],
            visible: false,
            investigation: {},
            contractTypeList: [],
            criterion:[],
            isClear: true,
            rebateAmount: '',
        });
    }

    loadData = () => {
        const { record: { investigationId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.view,
            data: { investigationId },
            dataType: 'json',
            doneResult: data => {
                const planList = data.data.investigation.planList ? data.data.investigation.planList : [];
                this.setState({
                    planList,
                    loading: false,
                    investigation: data.data.investigation,
                    bdUserList: data.data.investigation.bdUserList ? data.data.investigation.bdUserList : [],
                    paUserList: data.data.investigation.paUserList ? data.data.investigation.paUserList : [],
                    pmUserList: data.data.investigation.pmUserList ? data.data.investigation.pmUserList : [],
                });
            }
        };
        $.sendRequest(options);
    }

    loadAllCurrencyExchangeRateList = () => {
        const options = {
            method: 'post',
            url: API_URL.contract.queryAllCurrencyExchangeRate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                this.setState({
                    currencyList: data,
                });
            }
        };
        $.sendRequest(options);
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.typeConfigureList}`,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                contractTypeList: res.contractTypeList,
            });
        });
    }

    loadFileList = () => {
        const { record: { jdeApplyId } } = this.state;
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeApplyFileMetaById,
            data: {
                jdeApplyId,
                uploadType: 'CONTRACT',
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.data;
                fileList.forEach((item, index) => {
                    item.response = { fileMetaId: item.fileMateId };
                    item.uid = index;
                });
                this.setState({ fileList });
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    handleNoPassReason = value => {
        const { criterion } = this.state;
        const arr = [];
        criterion.forEach( el => {
            el.processed && arr.push(el)
        })
        const comments = arr.length ? value == 'DISAGREE' ? arr[arr.length-1].noPassReason : arr[arr.length-1].refuseReason : '';
        return comments
    }

    handleInputChange = (e, field) => {
        const { saveParams, allTrue } = this.state;
        const value = e.target.value;
        if (field == 'approvalStatus') {
            if (value == 'AGREE') {
                saveParams.comments = '';
            } else {
                saveParams.investigationJdeCode = '';
                saveParams.projectIdName = '';
                saveParams.investigationContractTypeId = undefined;
				saveParams.contractTypeValue = '';
				saveParams.invoiceRate = '';
				saveParams.autoLoadJdeInfo = '';
                saveParams.comments = !allTrue ? this.handleNoPassReason(value) : '';
            }
        }
        if (field == 'investigationJdeCode') {
            saveParams[field] = value.replace(/[^0-9a-zA-Z]/g, '');
        } else {
            saveParams[field] = value;
        }
        this.setState({ saveParams });
    }
	
	

    handleSelectChange = (value, key) => {
        const { saveParams } = this.state;
        const prevSigningUnit = saveParams.signingUnit;
        saveParams[key] = value;
        if (key === 'signingUnit') {
            const { signingUnitList } = this.props;
            const belongingToUnitList = (signingUnitList.find(i => i.unitOfSigningId == value) || {}).belongings || [];

            if (value && !belongingToUnitList.length) {
                saveParams.signingUnit = prevSigningUnit;
                message.warning('收入归属单位不能为空，请联系后台管理员为合同签署单位设置收入归属单位');
                return;
            }
            if (belongingToUnitList.length === 1) {
                saveParams.belongingToUnit = belongingToUnitList[0].unitOfBelongingId;
                saveParams.belongingToUnitName = belongingToUnitList[0].unitOfBelongingName; 
            } else {
                saveParams.belongingToUnit = undefined;
                saveParams.belongingToUnitName = undefined; 
            }
            this.setState({ belongingToUnitList });
        }
        // 币种的选择 展示当前的汇率
        if (key === 'currencyExchangeRateId') {
            const { currencyList = [] } = this.state;
            const rateItem = currencyList.find(i => i.currencyExchangeRateId == value);
            const { exchangeRate, currencyName, dateShow } = rateItem || {};
            saveParams.exchangeRate = exchangeRate;
            saveParams.currencyExchangeRate = exchangeRate;
            saveParams.currencyName = currencyName;
            saveParams.dateShow = dateShow;
            // saveParams.expectContractAmount = '';
            // saveParams.contractAmount = '';
            // saveParams.actualExpenseFee = '';
            // saveParams.taxationFee = '';
            // saveParams.actualFee = '';
        }
        if (key === 'lineOfBusiness') {
            saveParams.secondLineIds = undefined;
        }
        if (key === 'secondLineIds') {
            saveParams.secondLineIds = (value || []).join(',');
        }
        this.setState({ saveParams });
    }

    handleNumberChange = (value, key) => {
        const { saveParams } = this.state;
        saveParams[key] = value;
        this.setState({ saveParams });
    }
	
	loadJdeInfo = (e) => {
		 const {
   
            contractTypeList,
            investigation,
            saveParams,
            record,
        } = this.state;
		const {
            investigationJdeCode
        } = saveParams;
		
		if(record.contractOrLetterIsSign == '0' && (record.natureOfContract == 'FIRST_CONTRACT' || record.natureOfContract == 'RENEW_CONTRACT')) {
			saveParams.autoLoadJdeInfo = '';
			saveParams.invoiceRate = '';
			saveParams.investigationContractTypeId = null;
			this.setState({
			saveParams
			});
			return;
		}
		
		if(investigationJdeCode != null && investigationJdeCode != '') {
		//   const options = {
        //     method: 'post',
        //     url: API_URL.contract.queryJdeInfoByJdeCode,
        //     data: { jdeCode:investigationJdeCode},
        //     dataType: 'json',
        //     doneResult: data => {
		// 		//获取到了回传数据
		// 		if(data.investigationJdeContractCode && data.invoiceRate && data.contractTypeId) {
		// 			//saveParams.projectIdName = data.projectIdName;
		// 			saveParams.autoLoadJdeInfo = '1';
		// 			saveParams.invoiceRate = data.invoiceRate;
		// 			saveParams.investigationContractTypeId = String(data.contractTypeId);
		// 			saveParams.contractTypeValue = String(data.contractTypeValue);
		// 			this.setState({
		// 			saveParams
		// 			});
		// 		} else {
		// 			saveParams.autoLoadJdeInfo = '';
		// 			saveParams.invoiceRate = '';
		// 			saveParams.investigationContractTypeId = undefined;
		// 			this.setState({
		// 			saveParams
		// 			});
		// 		}
        //     }
        // };
        // $.sendRequest(options);
        this.queryChildJdeByInvId(investigationJdeCode);
        this.queryRebate(investigationJdeCode);
		} else {
			saveParams.autoLoadJdeInfo = '';
			saveParams.invoiceRate = '';
			saveParams.investigationContractTypeId = null;
			this.setState({
			saveParams
			});
		}

    }

    queryRebate = (investigationJdeCode) => {
        const options = {
            method: 'post',
            url: API_URL.contract.queryRebate,
            data: { investigationJdeCode },
            dataType: 'json',
            doneResult: res => {
                const { rebateAmount } = res;
                this.setState({
                    rebateAmount,
                });
            }
        };
        $.sendRequest(options);
    }

    queryChildJdeByInvId = jdeCodeData => {
        const { record, saveParams } = this.state;
        const { investigationId, contractIsSpecifiesAmount, natureOfContractShow, } = record;
        const {
            investigationJdeCode,
            relationJdeCode,
        } = saveParams;
      
        const jde = natureOfContractShow == '补充合同' ? '' : (natureOfContractShow == '终止合同' || natureOfContractShow == '终止函') ? relationJdeCode : investigationJdeCode;

        const options = {
            method: 'POST',
            url: API_URL.contract.queryChildJdeByInvId,
            data: {
                contractIsSigned: '1',
                investigationId,
                jdeCode: jdeCodeData ? jdeCodeData : jde,
            },
            dataType: 'json',
            doneResult: res => {
                const { list = [] } = res;
                if (contractIsSpecifiesAmount == '1') {
                    if (list.length === 0) {
                        saveParams.autoLoadJdeInfo = '';
                        saveParams.isAuto = false;
                        saveParams.invoiceRate = '';
                        saveParams.investigationContractTypeId = undefined;
                        saveParams.contractTypeValue = undefined;
                        this.setState({
                            saveParams
                        });
                    } else {
                        saveParams.autoLoadJdeInfo = '1';
                        saveParams.isAuto = false;
                        saveParams.invoiceRate = list[0].invoiceRate;
                        saveParams.investigationContractTypeId = String(list[0].contractTypeId);
                        saveParams.contractTypeValue = String(list[0].contractTypeValue);
                        this.setState({ saveParams });
                    }
                } else {
                    if (list.length === 0) {
                        saveParams.autoLoadJdeInfo = '';
                        saveParams.isAuto = true;
                        saveParams.invoiceRate = '';
                        saveParams.investigationContractTypeId = '23';
                        saveParams.contractTypeValue = '开票';
                        this.setState({ saveParams });
                    } else {
                        saveParams.autoLoadJdeInfo = '1';
                        saveParams.isAuto = false;
                        saveParams.invoiceRate = list[0].invoiceRate;
                        saveParams.investigationContractTypeId = String(list[0].contractTypeId);
                        saveParams.contractTypeValue = String(list[0].contractTypeValue);
                        this.setState({ saveParams });
                    }
                }
            }
        }
        $.sendRequest(options)
    }

    checkJdeApplyPrompt = params => {
        if( params.approvalStatus !== 'AGREE' ) {
            this.sendServer(params, false)
            return
        }
        const { record:{ jdeApplyId, jdeCode } } = this.state;
        const { currencyExchangeRateId, contractAmount, actualExpenseFee, taxationFee, investigationJdeCode } = params
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.checkJdeApplyPrompt,
            data: {
                jdeCode: investigationJdeCode,
                jdeApplyId,
                currencyExchangeRateId,
                contractAmount,
                actualExpenseFee,
                taxationFee,
            },
            dataType: 'json',
            doneResult: res => {
                const { criterion } = this.state;
                try {
                    criterion.forEach( (el, index) => {
                        if(!res[el.key] && !el.processed) {
                            el.index = index
                            throw el
                        }
                        el.processed = true;
                    })
                } catch (el) {
                    Modal.warning({
                        okText: '确定',
                        content: el.context,
                    });
                    el.processed = true;
                    criterion[el.index] = el;
                    this.setState({
                        loading: false,
                        criterion,
                        allTrue: false,
                    })
                    return
                }
                if( criterion.every( el => el.processed )) {
                    this.sendServer(params, false)
                }
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { businessList } = this.props;
        const { record, saveParams, currencyList, amounted = false, isClear } = this.state;
        const { jdeApplyId, isClinicalProject, contractOrLetterIsSign, natureOfContract, contractIsSpecifiesAmount } = record;
        //新增字段处理
        saveParams.isRealitySettle=record.contractOrLetterIsSign == 1?record.isRealitySettle?record.isRealitySettle:0:null;
        saveParams.isMsaSpecialContractReduce=record.isRealitySettle == 0?record.isDiscountTermValidity ==1?record.isMsaSpecialContractReduce?record.isMsaSpecialContractReduce:0:null:null;
        saveParams.isMsaSpecialDiscountCustom = saveParams.isMsaSpecialDiscountCustom?saveParams.isMsaSpecialDiscountCustom:record.isMsaSpecialDiscountCustom;
        saveParams.isDiscountTermValidity = saveParams.isDiscountTermValidity?saveParams.isDiscountTermValidity:record.isDiscountTermValidity;
        saveParams.discountContractAmount = record.discountContractAmount;
        saveParams.discountContractAmountNoTax = this.discountAmount();
        const {
            approvalStatus,
            investigationJdeCode,
            projectIdName,
            comments,
            investigationContractTypeId,
            lineOfBusiness,
            belongingToUnit,
            signingUnit,
            contractAmount,
            expectContractAmount,
            currencyExchangeRateId,
            exchangeRate,
            invoiceRate,
            actualExpenseFee,
            actualFee,
            taxationFee,
            secondLineIds,
        } = saveParams;
        const isClinicalPro = isClinicalProject == 1;
        const contractIsSign = contractOrLetterIsSign == '1';
        // 合同未签署，且不是临床项目
        const lineOfBusiness_editable = !contractIsSign && !isClinicalPro;
        const text = !contractIsSign ? '批' : '核';
        const currencyCode = (currencyList.find(i => i.currencyExchangeRateId == currencyExchangeRateId) || {})['currencyCode'];
        
        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
        if (lineOfBusiness_editable && !lineOfBusiness) {
            message.warning('请选择业务线');
            return;
        }
        if (lineOfBusiness_editable && (secondLineList || []).length && !secondLineIds) {
            message.warning('请选择执行业务线二级分类');
            return;
        }

        if (!signingUnit) {
            message.warning('请选择合同签署单位');
            return;
        }
        if (!belongingToUnit) {
            message.warning('请选择收入归属单位');
            return;
        }
        if (!currencyExchangeRateId) {
            message.warning('请选择币种');
            return;
        }
        if (currencyCode !== 'CNY' && !exchangeRate) {
            message.warning('请输入汇率');
            return;
        }
        if (contractIsSign) {
            if (!contractAmount && contractAmount !== 0) {
                message.warning('请输入合同额含税');
                return;
            } else {
                if (natureOfContract == 'FIRST_CONTRACT' && contractAmount <= 0) {
                    message.warning('合同性质为“首次合同”时，合同额含税不支持负数和零');
                    return;
                } else if (natureOfContract !== 'SUPPLEMENT_CONTRACT' && contractAmount === 0) {
                    message.warning('合同额含税不支持零');
                    return;
                }
            }
            if (!taxationFee && taxationFee !== 0) {
                message.warning('请输入合同额税费');
                return;
            }
        } else if (!contractIsSign) {
            if (!expectContractAmount && expectContractAmount !== 0) {
                message.warning('请输入预计合同金额');
                return;
            } else {
                if (natureOfContract == 'FIRST_CONTRACT' && expectContractAmount < 0) {
                    message.warning('合同性质为“首次合同”时，预计合同金额不支持负数');
                    return;
                }
            }
        }
        if (!approvalStatus) {
            message.warning(`请选择审${text}结论`);
            return;
        }
        if (approvalStatus == 'AGREE') {
            if (!investigationJdeCode) {
                message.warning('请输入JDE项目号');
                return;
            } else if (investigationJdeCode && investigationJdeCode.length != 12) {
                message.warning('JDE项目号格式不正确:固定为12位，可由数字字母组成');
                return;
            }
            if (!projectIdName) {
                message.warning('请输入名称(ProjectID)');
                return;
            }
            if (contractIsSign && !investigationContractTypeId) {
                message.warning('请选择计收入确认方式');
                return;
            }
            if (contractIsSign && !invoiceRate && invoiceRate !== 0) {
                message.warning('请输入发票税率');
                return;
            }
        } else if (approvalStatus == 'REJECT' && !comments) {
            message.warning('请输入拒绝原因');
            return;
        } else if (approvalStatus == 'DISAGREE' && !comments) {
            message.warning(`请输入审${text}不通过原因`);
            return;
        }
        
        if (currencyCode === 'CNY') {
            saveParams.initialExpectContractAmount = '';  //预计合同金额（原币）
            saveParams.initialContractAmount = '';  //合同额含税（原币）
            saveParams.initialActualExpenseFee = '';  //实报实销费（原币）
            saveParams.initialActualFee = ''; //实报实销税费(原币)
            saveParams.initialTaxationFee = ''; //税费（原币）
        } else {
            saveParams.initialExpectContractAmount = expectContractAmount;  //预计合同金额（原币）
            saveParams.initialContractAmount = contractAmount;  //合同额含税（原币）
            saveParams.initialActualExpenseFee = actualExpenseFee;  //实报实销费（原币）
            saveParams.initialActualFee = actualFee; //实报实销税费(原币)
            saveParams.initialTaxationFee = taxationFee; //税费（原币）
        }

        const params = {
            jdeApplyId,
            ...saveParams,
        };

        if (currencyCode !== 'CNY') {
            params.expectContractAmount = (expectContractAmount || expectContractAmount === 0) ? (expectContractAmount * exchangeRate).toFixed(2) : '';  //预计合同金额（人民币）
            params.contractAmount = (contractAmount || contractAmount === 0) ? (contractAmount * exchangeRate).toFixed(2) : '';  //合同额含税（人民币）
            params.actualExpenseFee = (actualExpenseFee || actualExpenseFee === 0) ? (actualExpenseFee * exchangeRate).toFixed(2) : '';  //实报实销费（人民币）
            params.actualFee =  (actualFee || actualFee === 0) ? (actualFee * exchangeRate).toFixed(2) : ''; //实报实销税费(人民币)
            params.taxationFee = (taxationFee || taxationFee === 0) ? (taxationFee * exchangeRate).toFixed(2) : ''; //税费（人民币）
        }
        const { curRole } = sessionStorage;
        const isFIN = curRole === 'FIN';
        // 计收入确认方式确认提示仅在合同已签署时弹出(字段显示与必填校验均以 contractIsSign 为前提，未签署时页面上无该字段，不应提示)
        if (contractIsSign && investigationContractTypeId != 23 && approvalStatus == 'AGREE' && contractIsSpecifiesAmount == '0' && isClear && isFIN) {
            Modal.warning({
                title: '',
                okText: '确定',
                content: '合同金额为非明标金额，请确认计收入确认方式',
                onOk: () => {
                    this.setState({ isClear: false });
                }
            })
        } else {
            this.checkJdeApplyPrompt(params)
        }
    }

    sendServer = (params, isCheck) => {
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.contract.finApprovalIssueCode,
            data: {
                isCheck,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { message: info, success } = res;
                if (info) {
                    Modal.confirm({
                        iconType: 'exclamation-circle',
                        title: <div style={{ marginLeft: 42 }}>{info}</div>,
                        onOk: () => {
                            this.sendServer(params, true);
                        },
                        onCancel: () => {
                            this.setState({ loading: false });
                        },
                    })
                } else {
                    message.success(success);
                    this.setState({
                        loading: false,
                    }, () => {
                        this.hide();
                        this.props.loadData();
                    });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getFileList = () => {
        const { fileList } = this.state;
        return fileList.map(i => <a onClick={e => this.downLoadFile(e, i.response.fileMetaId)}>{i.name}<br /></a>);
    }

    getContractDom = () => {
        const {
            saveParams: {
                currencyExchangeRateId,
                actualExpenseFee,
                taxationFee,
                actualFee,
                contractAmount,
                exchangeRate,
                currencyName,
            },
            currencyList,
        } = this.state;
        const asterisk = <span style={{color: 'red'}}>*</span>;
        const rate = this.calculateRate();
        const currencyCode = (currencyList.find(i => i.currencyExchangeRateId == currencyExchangeRateId) || {})['currencyCode'];
        return (
            currencyCode === 'CNY' ?
                <div className="FeeBackground" style={{ width: '70%', marginLeft: 20 }}>
                    <div style={{position:'absolute',top:0,left:0,right:'88%',bottom:0,background:'#f9f9f9',borderRight:"1px solid #ccc"}}>
                        <span style={{position:"absolute",left:"10px",top:"50%",transform:'translateY(-50%)'}}>&nbsp;其中<br/>需扣除</span>
                    </div>
                    <div style={{height:"100%",marginLeft:'12%'}}>
                        <li className="preview-item">
                            <div className="item" style={{ width: '100%' }}>
                                <label className="ui-label">实报实销(不含税)/人民币</label>
                                <span className="ui-text">
                                    <InputNumber
                                        maxLength="17"
                                        max={99999999999}
                                        style={{width: 100 }}
                                        value={actualExpenseFee}
                                        onChange={value => this.handleNumberChange(value, 'actualExpenseFee')}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        precision={2}
                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                    />
                                    &nbsp;元
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item" style={{ width: '100%' }}>
                                <label className="ui-label">实报实销税费/人民币</label>
                                <span className="ui-text">
                                    <InputNumber
                                        maxLength="17"
                                        max={99999999999}
                                        style={{width: 100 }}
                                        value={actualFee}
                                        onChange={value => this.handleNumberChange(value, 'actualFee')}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        precision={2}
                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                    />
                                    &nbsp;元
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item" style={{ width: '100%' }}>
                                <label className="ui-label">{asterisk}合同额税费/人民币</label>
                                <span className="ui-text">
                                    <InputNumber
                                        maxLength="17"
                                        max={99999999999}
                                        style={{width: 100 }}
                                        value={taxationFee}
                                        onChange={value => this.handleNumberChange(value, 'taxationFee')}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        precision={2}
                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                    />
                                    &nbsp;元
                                </span>
                            </div>
                        </li>
                    </div>
                </div>
            :
                <div className="jde-rate">
                    <div>
                        <div className="left" style={{ width:'55%'}}>
                            <div className="left lable" style={{width:'59.4%'}}>{asterisk}合同额含税/原币</div>
                            <div className="right text-com" style={{width:'37%'}}>
                                <InputNumber
                                    maxLength="17"
                                    precision={2}
                                    max={99999999999}
                                    style={{ width: 100 }}
                                    value={contractAmount}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                    onChange={value => this.handleNumberChange(value, 'contractAmount')}
                                />&nbsp;{currencyName}
                            </div>
                        </div>
                        <div className="right" style={{ width:'45%'}}>
                            <div className="left lable" style={{width:'50%'}}>合同额含税/人民币</div>
                            <div className="right text-com" style={{width:'46%'}}>
                                {format('money', contractAmount, exchangeRate)}&nbsp;元
                            </div>
                        </div>
                    </div>
                    <div className="jde-top">
                        <div className="left lable" style={{width:'10%',textAlign:'center',borderRight:0}}>其中<br/>需扣除</div>
                        <div className="right jde-left" style={{width:'90%'}}>
                            <div>
                                <div className="left" style={{ width:'50%'}}>
                                    <div className="left lable" style={{width:'50%'}}>实报实销(不含税)/原币</div>
                                    <div className="right text-com" style={{width:'46%'}}>
                                        <InputNumber
                                            maxLength="17"
                                            precision={2}
                                            max={99999999999}
                                            style={{ width: 100 }}
                                            value={actualExpenseFee}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            onChange={value => this.handleNumberChange(value, 'actualExpenseFee')}
                                        />&nbsp;{currencyName}
                                    </div>
                                </div>
                                <div className="right" style={{ width:'50%'}}>
                                    <div className="left lable" style={{width:'50%'}}>实报实销(不含税)/人民币</div>
                                    <div className="right text-com" style={{width:'46%'}}>
                                        {format('money', actualExpenseFee, exchangeRate)}&nbsp;元
                                    </div>
                                </div>
                            </div>
                            <div className="jde-bottom">
                                <div  className="left" style={{ width:'50%'}}>
                                    <div className="left lable" style={{width:'50%'}}>实报实销税费原币</div>
                                    <div className="right text-com" style={{width:'46%'}}>
                                        <InputNumber
                                            maxLength="17"
                                            precision={2}
                                            max={99999999999}
                                            style={{ width: 100 }}
                                            value={actualFee}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            onChange={value => this.handleNumberChange(value, 'actualFee')}
                                        />&nbsp;{currencyName}
                                    </div>
                                </div>
                                <div className="right" style={{ width:'50%'}}>
                                    <div className="left lable" style={{width:'50%'}}>实报实销税费/人民币</div>
                                    <div className="right text-com" style={{width:'46%'}}>
                                        {format('money', actualFee, exchangeRate)}&nbsp;元
                                    </div>
                                </div>
                            </div>
                            <div className="jde-bottom">
                                <div className="left" style={{ width:'50%'}}>
                                    <div className="left lable" style={{width:'50%'}}>{asterisk}合同额税费/原币</div>
                                    <div className="right text-com" style={{width:'46%'}}>
                                        <InputNumber
                                            maxLength="17"
                                            precision={2}
                                            max={99999999999}
                                            style={{ width: 100 }}
                                            value={taxationFee}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                            onChange={value => this.handleNumberChange(value, 'taxationFee')}
                                        />&nbsp;{currencyName}
                                    </div>
                                </div>
                                <div className="right" style={{ width:'50%'}}>
                                    <div className="left lable" style={{width:'50%'}}>合同额税费/人民币</div>
                                    <div className="right text-com" style={{width:'46%'}}>
                                        {format('money', taxationFee, exchangeRate)}&nbsp;元
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="jde-top">
                        <div className="left lable" style={{width:'32.6%'}}>合同税率</div>
                        <div className="right text-com" style={{width:'60.4%'}}>{rate}%</div>
                    </div>
                </div>
        )
    }

    calculateRate = () => {
        const { saveParams: { taxationFee, contractAmount } } = this.state;
        // 税率
        let rate = '';
        if ((taxationFee || taxationFee === 0) && (contractAmount || contractAmount === 0)) {
            if (contractAmount - taxationFee == 0) {
                if (contractAmount === 0) {
                    rate = 0;
                } else {
                    rate = 100;
                }
            } else {
                rate = taxationFee / (contractAmount - taxationFee) * 100;
                rate = Number.isNaN(rate) ? '' : myFixed(rate ,2);
            }
        }
        function myFixed(num, digit) {
            if(Object.is(parseFloat(num), NaN)) {
            return console.log(`传入的值：${num}不是一个数字`);
            }
            num = parseFloat(num);
            return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
        }
        return rate;
    }

    discountAmount = () =>{
        const { discountContractAmount } = this.state.record;
        const  rate = this.calculateRate()
        //优惠金额（不含税）
        let discountContractAmountNoTaxValue ='';
        if((discountContractAmount || discountContractAmount == 0)&& (rate || rate == 0)){
            discountContractAmountNoTaxValue = discountContractAmount*(1-rate/100);
            discountContractAmountNoTaxValue = Number.isNaN(discountContractAmountNoTaxValue) ? '' : myFixed(discountContractAmountNoTaxValue,2)
            // handleChange(discountContractAmountNoTaxValue, 'discountContractAmountNoTax')
        }
        function myFixed(num, digit) {
            if(Object.is(parseFloat(num), NaN)) {
            return console.log(`传入的值：${num}不是一个数字`);
            }
            num = parseFloat(num);
            return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
        }
        return discountContractAmountNoTaxValue;
    }
    

    getDomList = () => {
        const { businessList, signingUnitList } = this.props;
        const { record, saveParams, belongingToUnitList, currencyList, investigation } = this.state;
        const { 
            jdeApplySceneId, 
            contractOrLetterIsSign, 
            natureOfContractShow, 
            isClinicalProject,
            isRealitySettle,
            isMsaSpecialContractReduce,
            isMsaSpecialDiscountCustom,
            isDiscountTermValidity,
            discountContractAmount,
            contractOrLetterIsSignShow,
        } = record;
        const { 
            signingUnit,
            belongingToUnitName, 
            belongingToUnit, 
            currencyExchangeRateId, 
            exchangeRate, 
            dateShow, 
            currencyName, 
            currencyExchangeRate, 
            expectContractAmount, 
            contractAmount, 
            lineOfBusiness, 
            secondLineIds,
        } = saveParams;
        const { currencyCode } = getMatchOption(currencyList, 'currencyExchangeRateId', currencyExchangeRateId);
        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
        
        const rate = this.calculateRate();
        const discountContractAmountNoTaxValue = this.discountAmount();
        const isClinicalPro = isClinicalProject == 1;
        const contractIsSign = contractOrLetterIsSign == '1';
        const isFirstContract = natureOfContractShow == '首次合同';
        const showRealitySettle = contractOrLetterIsSignShow=='是';
        const is1Or2 = jdeApplySceneId == 1 || jdeApplySceneId == 2;
        const showSecondLine = (secondLineList || []).length > 0;
        const { invNature } = getMatchOption(secondLineList, 'typeConfigureId', secondLineIds);
        // 不是临床项目
        const lineOfBusiness_editable = is1Or2 && !isClinicalPro;
        
        const signingUnitOptions = signingUnitList.map(i => <Option key={String(i.unitOfSigningId)}>{i.unitOfSigningName}</Option>);
        const belongingToUnitOptions = belongingToUnitList.map(i => <Option key={String(i.unitOfBelongingId)}>{i.unitOfBelongingName}</Option>);
        const currencyOption = currencyList.map(i => <Option key={String(i.currencyExchangeRateId)}>{`${i.currencyName}(${i.currencyCode})`}</Option>);
        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId} disabled={!(i.groupId == 2)}>{i.typeValue}</Option>);
        const secondLineOption = (secondLineList || []).map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);

        const columns = [{
            name: '系统中是否有此项目',
            value: record.jdeApplyIsInvestigationExistsShow,
        }, {
            name: '项目简称',
            value: record.investigationName,
        }, {
            name: 'JDE主项目号',
            value: record.jdeCode,
        }, {
            name: '此项目是否为临床项目',
            value: record.isClinicalProjectShow,
        }, {
            name: '业务机会编号',
            value: investigation.businessOpportunityNum,
        }, {
            name: '临床评估单号',
            value: investigation.evaluateCode,
        }, {
            name: '合同或函证是否签署',
            value: record.contractOrLetterIsSignShow,
        }, {
            name: '合同性质',
            value: record.natureOfContractShow,
        }];
        if (!is1Or2) {
            columns.push({
                name: '关联JDE号',
                value: record.relationJdeCode,
            });
        }
        columns.push(
        // {
        // name: '申办方',
        // value: record.sponsorName,
        // }, 
        {
            name: '合同签署方',
            value: record.contractSignCompanyName,
            }, 
        {
            name: '项目识别码',
            value: record.investigationIdentifyCode,
        }, {
            name: '项目编号',
            value: record.customerProjectCode,
        }, {
            name: '客户全名',
            value: record.customerCompanyName,
        }, {
            name: '客户JDE号',
            value: record.customerJdeCode,
        }, {
            name: 'BA',
            value: format('joint', record.baName, record.baCode),
        });
        if (is1Or2) {
            columns.push({
                name: '研究产品类型',
                value: record.researchProductTypeShow,
            }, {
                name: '项目分期',
                value: record.investigationByStageName,
            }, {
                name: '疾病',
                value: record.diseaseName,
            }, {
                name: '疾病分类',
                value: record.diseaseClassName,
            }, {
                name: '项目领域',
                value: record.investigationAreaName,
            }, {
                name: '受试者类型',
                value: record.testeeTypeName,
            });
        }
        columns.push({
            name: <Text asterisk={lineOfBusiness_editable}>业务线</Text>,
            value: (
                lineOfBusiness_editable ?
                    <Select
                        placeholder="请选择"
                        style={{ width: 182 }}
                        value={saveParams.lineOfBusiness}
                        onChange={value => this.handleSelectChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                :
                    record.lineOfBusinessString
            ),
        })
        if (showSecondLine) {
            columns.push({
                name: <Text asterisk={lineOfBusiness_editable}>执行业务线二级分类</Text>,
                value: (
                    lineOfBusiness_editable ?
                        <Select
                            mode="multiple"
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 182 }}
                            value={secondLineIds ? secondLineIds.split(',') : []}
                            onChange={value => this.handleSelectChange(value, 'secondLineIds')}
                        >
                            {secondLineOption}
                        </Select>
                    :
                        record.secondLineNames
                )
            });
        }
        if (is1Or2) {
            columns.push({
                name: '项目分类',
                value: record.investigationTypeName,
            });
        }
        if (isClinicalPro) {
            columns.push({
                name: '项目性质',
                value: invNature,
            });
        }
        columns.push({
            name: <Text asterisk={true}>合同签署单位</Text>,
            value: (
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 182}}
                    value={signingUnit ? String(signingUnit) : undefined}
                    onChange={value => this.handleSelectChange(value, 'signingUnit')}
                >
                    {signingUnitOptions}
                </Select>
            ),
        }, {
            name: <Text asterisk={true}>收入归属单位</Text>,
            value: (
                belongingToUnitList.length <= 1 ?
                    (belongingToUnitName || '')
                :
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 182}}
                        value={belongingToUnit ? String(belongingToUnit) : undefined}
                        onChange={value => this.handleSelectChange(value, 'belongingToUnit')}
                    >
                        {belongingToUnitOptions}
                    </Select>
            ),
        });
        if (contractIsSign) {
            columns.push({
                name: '合同中是否明标合同金额',
                value: record.contractIsSpecifiesAmountShow,
            });
        }
        columns.push({
            name: <Text asterisk={true}>币种</Text>,
            value: (
                <Select
                    placeholder="请选择"
                    style={{width: 182}}
                    value={currencyExchangeRateId ? String(currencyExchangeRateId) : undefined}
                    onChange={value => this.handleSelectChange(value, 'currencyExchangeRateId')}
                >
                    {currencyOption}
                </Select>
            ),
        }, {
            name: <Text asterisk={currencyCode !== 'CNY'}>汇率</Text>,
            value: (
                currencyCode === 'CNY' ?
                    exchangeRate
                :
                    <div className="inline-block">
                        <InputNumber
                            placeholder="请输入"
                            style={{width: 182}}
                            value={exchangeRate}
                            onChange={value => this.handleNumberChange(value, 'exchangeRate')}
                        />
                        {
                            currencyCode !== 'CNY' &&
                            <div style={{paddingTop:10,color:'blue'}}>【{dateShow}: 1{currencyName}={currencyExchangeRate}人民币】</div>
                        }
                    </div>
            ),
        });
        if (!contractIsSign) {
            const expectContractAmountDom = width => (
                <InputNumber
                    maxLength="17"
                    precision={2}
                    max={99999999999}
                    style={{ width }}
                    value={expectContractAmount}
                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                    onChange={value => this.handleNumberChange(value, 'expectContractAmount')}
                />
            );
            if (currencyCode === 'CNY') {
                columns.push({
                    name: <Text asterisk={true}>预计合同金额/人民币</Text>,
                    value: (
                        <div className="inline-block">
                            {expectContractAmountDom(182)}&nbsp;元
                        </div>
                    ),
                });
            } else {
                columns.push({
                    type: 'custom',
                    value: (
                        <div className="jde-rate">
                            <div className="left" style={{ width:'50%'}}>
                                <div className="left lable" style={{width:'50%'}}><Text asterisk={true}>预计合同金额/原币</Text></div>
                                <div className="right text-com" style={{width:'50%'}}>
                                    {expectContractAmountDom(100)}&nbsp;{currencyName}
                                </div>
                            </div>
                            <div className="right" style={{ width:'50%'}}>
                                <div className="left lable" style={{width:'50%'}}>预计合同金额/人民币</div>
                                <div className="right text-com" style={{width:'50%'}}>
                                    {format('money', expectContractAmount, exchangeRate)}&nbsp;元
                                </div>
                            </div>
                        </div>
                    ),
                });
            }
            columns.push({
                type: 'custom',
                value: (
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">备注</label>
                            <span className="ui-text" style={{width:550}}>{record.comments}</span>
                        </div>
                    </li>
                )
            });
        } else {
            if (currencyCode === 'CNY') {
                columns.push({
                    name: <Text asterisk={true}>合同额含税/人民币</Text>,
                    value: (
                        <div className="inline-block">
                            <InputNumber
                                maxLength="17"
                                precision={2}
                                max={99999999999}
                                style={{ width: 182 }}
                                value={contractAmount}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                onChange={value => this.handleNumberChange(value, 'contractAmount')}
                            />&nbsp;元
                        </div>
                    ),
                }, {
                    name: '合同税率',
                    value: `${rate} %`,
                });
            }
            columns.push({
                type: 'custom',
                value: this.getContractDom()
            });
            if (isFirstContract) {
                columns.push({
                    name: <span>关联JDE是否需要扣&nbsp;&nbsp;<br />除相应金额</span>,
                    value: record.relateJdeIsDeductAmountShow,
                });
            }
            if(showRealitySettle){
                columns.push(
                    {
                        name: '是否据实结算',
                        value:record.realitySettleShow,
                    }
                )
                if(isRealitySettle==0 && isMsaSpecialDiscountCustom==1 && isDiscountTermValidity==1){
                    columns.push({
                        name: <span>MSA特殊优惠是否从&nbsp;&nbsp;<br />合同额中扣减</span>,
                        value:record.msaSpecialContractReduceShow,
                    })
                    if( isMsaSpecialContractReduce==1){
                        columns.push({
                            name: <span>优惠金额（含税）&nbsp;&nbsp;<br />/人民币</span>,
                            value:(<span>{discountContractAmount}&nbsp;元</span>),
                        },{
                            name: <span>优惠金额（不含税）&nbsp;&nbsp;<br />/人民币</span>,
                            value:(<span>{discountContractAmountNoTaxValue}&nbsp;元</span>),
                        })
                    }
                }
            }
            columns.push({
                name: '合同开始时间',
                value: record.contractStartDateShow,
            }, {
                name: '合同结束时间',
                value: record.contractEndDateShow,
            }, {
                name: '是否拥有纸质合同',
                value: record.havePaperContractShow,
            }, {
                type: 'custom',
                value: (
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">备注</label>
                            <span className="ui-text" style={{width:550}}>{record.comments}</span>
                        </div>
                    </li>
                )
            }, {
                type: 'custom',
                value: (
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">合同附件</label>
                            <span className="ui-text" style={{width:550}}>{this.getFileList()}</span>
                        </div>
                    </li>
                )
            });
        }

        let idx = 0;
        const result = [];
        for (let i = 0, len = columns.length; i < len; i++) {
            const firColumn = columns[i];
            const secColumn = columns[i + 1];
            if (!firColumn.type && secColumn && !secColumn.type) {
                result.push(
                    <li key={idx++} className="preview-item">
                        {this.getDivDom(firColumn)}
                        {this.getDivDom(secColumn)}
                    </li>
                );
                i++;
            } else if (!firColumn.type) {
                result.push(
                    <li key={idx++} className="preview-item">
                        {this.getDivDom(firColumn)}
                    </li>
                );
            } else {
                result.push(
                    <div key={idx++}>
                        {this.getDivDom(firColumn)}
                    </div>
                );
            }
        }
        return result;
    }

    getDivDom = ({ name, value }) => (
        <div className="item">
            <label className="ui-label">{name}</label>
            <span className="ui-text">{value}</span>
        </div>
    )

    getUsers = (list) => {
        return (list || []).map((d, i) => (
            d.workStatus == 'LEFT' ?
                <span style={{ color: '#ccc' }}>{d.userName}{(i < list.length - 1) && '；'}</span>
                :
                <span>{d.userName}{(i < list.length - 1) && '；'}</span>
        ));
    }

    render() {
        const { businessList } = this.props;
        const {
            visible,
            loading,
            planList = [],
            bdUserList = [],
            paUserList = [],
            pmUserList = [],
            contractTypeList,
            investigation,
            saveParams,
            record,
            rebateAmount,
            markRed,
        } = this.state;
        const { contractOrLetterIsSign } = record;
        const {
            approvalStatus,
            investigationJdeCode,
            contractAmount,
            investigationContractTypeId,
			contractTypeValue,
            projectIdName,
            comments,
            invoiceRate,
        } = saveParams;
        const {
            isClinicalProject,
            investigationAreaId,
            investigationMedicineType,
            byStageNames,
            investigationByStageRemark,
            administrationMode,
        } = investigation;
        const pmObj = pmUserList.length > 0 ? pmUserList.filter(d => d.isMain)[0] : {};
        const bigPM = pmObj.userName ? <span style={{ color: pmObj.workStatus == 'LEFT' && '#ccc' }}>{pmObj.userName}</span> : '';
        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', investigation.lineOfBusiness);
        const showSecondLine = (secondLineList || []).length > 0;

        const options = planList.map(item => {
            return (
                <div className="item">
                    {
                        item.investigationPlanType != "Type_FTE" ?
                            item.investigationPlanName != '中心' ?
                                <label className="ui-label">
                                    津石计划{item.investigationPlanName}
                                    {item.investigationPlanType == 'Type_Random' && <span>&nbsp;&nbsp;<br /></span>}
                                    数量
                                </label>
                            :
                                <label className="ui-label">津石计划负责中心&nbsp;&nbsp;<br />数量</label>
                        :
                            <label className="ui-label">合同{item.investigationPlanName}数</label>
                    }
                    {
                        item.investigationPlanName != 'FTE' ?
                            <span className="ui-text">{item.planAmount}</span>
                        :
                            <span className="ui-text">{item.planAmountShow}</span>
                    }
                </div>
            )
        });
        const contractTypeOptions = contractTypeList.map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);
		
        const asterisk = <span style={{color: 'red'}}>*</span>;

        const contractIsSign = contractOrLetterIsSign == '1';
		
		const autoLoadJdeInfo = saveParams.autoLoadJdeInfo == '1';
        return (
            <Modal
                title="审批发号"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName={markRed ? "red-glow-modal" : "vertical-center-modal"}
                bodyStyle={{ maxHeight: 500 }}
                confirmLoading={loading}
                maskClosable={false}
                width="820px"
            >
                <div className="cont-cont">
                    <Spin spinning={loading}>
                        <ul className="preview-list nobg deliver-code" style={{ marginBottom: 10 }}>
                            <div style={{ padding: 10 }}>
                                <li className="title preview-item"><h4>1.JDE建号申请</h4></li>
                                {this.getDomList()}
                                <li className="title preview-item"><h4>2.基本信息</h4></li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">项目简称</label>
                                        <span className="ui-text" style={{ width: 558 }}>{investigation.investigationName}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item" style={{ width: "100%", wordBreak: "break-all" }}>
                                        <label className="ui-label">项目名称</label>
                                        <span className="ui-text" style={{ width: 558 }}>{investigation.investigationSpecialName}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">项目识别码</label>
                                        <span className="ui-text">{investigation.investigationIdentifyCode}</span>
                                    </div>
                                    <div className="item">
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">项目编号</label>
                                        <span className="ui-text">{investigation.investigationCode}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">项目类型</label>
                                        <span className="ui-text">{investigation.investigationGlobalTypeName}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">项目级别</label>
                                        <span className="ui-text">{investigation.levelName}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">项目阶段</label>
                                        <span className="ui-text">{investigation.stageNameShowX}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">此项目是否为临床项目</label>
                                        <span className="ui-text">{isClinicalProject === 1 ? '是' : isClinicalProject === 0 ? '否' : ''}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">研究产品类型</label>
                                        <span className="ui-text">{investigation.researchProductTypeShow}</span>
                                    </div>
                                </li>
                                {
                                    
                                    (investigationMedicineType == 'Research_drugs') && (investigationAreaId == '1') &&
                                    <li className="preview-item">
                                        <div className="item">&nbsp;</div>
                                        <div className="item">
                                            <label className="ui-label">治疗方式</label>
                                            <span className="ui-text">{investigation.treatmentMethodShow}</span>
                                        </div>
                                    </li>
                                }
                                <li className="preview-item">
                                    <div className="item">&nbsp;</div>
                                    <div className="item">
                                        <label className="ui-label">药物(疗法)分类&nbsp;&nbsp;<br />/主要作用靶点</label>
                                        <span className="ui-text">{investigation.drugMainTargets}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">&nbsp;</div>
                                    <div className="item">
                                        <label className="ui-label">{investigationMedicineType == 'Research_drugs' ? '研究药物通用名称' : investigationMedicineType == 'Technology' ? '技术名称' : '产品具体名称'}</label>
                                        <span className="ui-text">{investigation.investigationMedicine}</span>
                                    </div>
                                </li>
                                {
                                    (investigationMedicineType == 'Research_drugs') &&
                                    <li className="preview-item">
                                        <div className="item">&nbsp;</div>
                                        <div className="item">
                                            <label className="ui-label">给药方式</label>
                                            <span className="ui-text">{investigation.administrationModeShow}</span>
                                        </div>
                                    </li>
                                }
                                {
                                    (investigationMedicineType == 'Research_drugs') && (administrationMode == '36') &&
                                    <li className="preview-item">
                                        <div className="item">&nbsp;</div>
                                        <div className="item">
                                            <label className="ui-label clearAfter">给药方式备注:</label>
                                            <span className="ui-text">{investigation.administrationModeRemark}</span>
                                        </div>
                                    </li>
                                }
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">项目分期</label>
                                        <span className="ui-text">{investigationByStageRemark ? `${byStageNames}(${investigationByStageRemark})` : byStageNames}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">疾病</label>
                                        <span className="ui-text">{investigation.diseaseName}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">疾病分类</label>
                                        <span className="ui-text">{investigation.diseaseClassName}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">项目领域</label>
                                        <span className="ui-text">{investigation.investigationAreaName}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">受试者类型</label>
                                        <span className="ui-text">{investigation.testeeTypeName}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">业务线</label>
                                        <span className="ui-text">{investigation.lineOfBusinessString}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    {
                                        showSecondLine &&
                                        <div className="item">
                                            <label className="ui-label">执行业务线二级分类</label>
                                            <span className="ui-text">{investigation.secondLineNames}</span>
                                        </div>
                                    }
                                    {
                                        investigation.secondLineNames === '非盲' &&
                                        <div className="item">
                                            <label className="ui-label">配套盲态项目</label>
                                            <span className="ui-text">{investigation.blindInvestigationName}</span>
                                        </div>
                                    }
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">项目性质</label>
                                        <span className="ui-text">{investigation.invNature}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">项目分类</label>
                                        <span className="ui-text">{investigation.typeName}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">合同签署方</label>
                                        <span className="ui-text">{investigation.contractSignCompanyName}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">申办方</label>
                                        <span className="ui-text">{investigation.investigationSponsor}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">CRO</label>
                                        <span className="ui-text">{investigation.cro}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    {options[0]}
                                    {options[1]}
                                </li>
                                <li className="preview-item">
                                    {options[2]}
                                    {options[3]}
                                </li>
                                <li className="title preview-item"><h4>3.项目负责人</h4></li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">大项目经理</label>
                                        <span className="ui-text">{bigPM}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">项目经理</label>
                                        <span className="ui-text">{this.getUsers(pmUserList)}</span>
                                    </div>
                                </li>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">项目管理员</label>
                                        <span className="ui-text">{this.getUsers(paUserList)}</span>
                                    </div>
                                    <div className="item">
                                        <label className="ui-label">BD</label>
                                        <span className="ui-text">{this.getUsers(bdUserList)}</span>
                                    </div>
                                </li>
                                <hr style={{ margin: '10px 0' }} />
                                <li className="preview-item" style={{background: 'none'}}>
                                    <div className="item" style={{ display: 'flex', marginLeft: 50 }}>
                                        <label className="ui-label">{asterisk}审{!contractIsSign ? '批' : '核'}结论</label>
                                        <span className="ui-text" style={{ width: 520 }}>
                                            <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                                                <Radio value='AGREE'>审{!contractIsSign ? '批' : '核'}通过</Radio>
                                                <Radio value='REJECT'>拒绝发号</Radio>
                                                <Radio value='DISAGREE'>审{!contractIsSign ? '批' : '核'}不通过</Radio>
                                            </RadioGroup>
                                        </span>
                                    </div>
                                </li>
                                {
                                    approvalStatus == 'AGREE' &&
                                    <div>
                                        <li className="preview-item" style={{background: 'none'}}>
                                            <div className="item">
                                                <label className="ui-label">{asterisk}JDE项目号</label>
                                                <span className="ui-text">
                                                    <Input
                                                        maxLength={12}
                                                        placeholder="请输入"
                                                        style={{width: 182}}
                                                        value={investigationJdeCode}
                                                        onChange={e => this.handleInputChange(e, 'investigationJdeCode')}
														onBlur={e => this.loadJdeInfo(e)}
                                                    />
                                                </span>
                                            </div>
                                        </li>
                                        {
                                            (contractAmount < 0) &&
                                            <li className="preview-item" >
                                                <div className="item">
                                                    <label className="ui-label">rebate含税金额/原币</label>
                                                    <span className="ui-text" style={{ color: 'red' }}>
                                                        {rebateAmount}
                                                    </span>
                                                </div>
                                            </li>
                                        }
                                        <li className="preview-item" style={{background: 'none'}}>
                                            <div className="item">
                                                <label className="ui-label">{asterisk}名称(ProjectID)</label>
                                                <span className="ui-text">
                                                    <Input
                                                        placeholder="请输入"
                                                        style={{width: 182}}
                                                        value={projectIdName}
                                                        onChange={e => this.handleInputChange(e, 'projectIdName')}
                                                    />
                                                </span>
                                            </div>
                                        </li>
                                        {
                                            contractIsSign &&
                                            <li className="preview-item" style={{background: 'none'}}>
                                                <div className="item">
                                                    <label className="ui-label">{asterisk}计收入确认方式</label>
													{
													!autoLoadJdeInfo &&
                                                    (
                                                        saveParams.isAuto
                                                        ?
                                                        <span className="ui-text">{contractTypeValue}</span>
                                                        :
                                                        <span className="ui-text">
                                                            <Select
                                                                placeholder="请选择"
                                                                style={{width: 182}}
                                                                value={investigationContractTypeId}
                                                                onChange={value => this.handleSelectChange(value, 'investigationContractTypeId')}
                                                            >
                                                                {contractTypeOptions}
                                                            </Select>
                                                        </span>
                                                    )
													
													}
													{
													 autoLoadJdeInfo && <span className="ui-text">{contractTypeValue}</span>
													}
                                                </div>
                                            </li>
                                        }
                                        {
                                            contractIsSign &&
                                            <li className="preview-item" style={{background: 'none'}}>
                                                <div className="item">
                                                    <label className="ui-label">{asterisk}发票税率</label>
													{
													!autoLoadJdeInfo &&
                                                    <span className="ui-text">
                                                        <InputNumber
                                                            precision={2}
                                                            placeholder="请输入"
                                                            style={{width: 162}}
                                                            value={invoiceRate}
                                                            onChange={e => this.handleNumberChange(e, 'invoiceRate')}
                                                        />&nbsp; %
                                                    </span>
													}
													{
														autoLoadJdeInfo && <span className="ui-text">{invoiceRate}&nbsp; %</span>
													}
                                                </div>
                                            </li>
                                        }
                                    </div>
                                }
                                {
                                    approvalStatus == 'REJECT' &&
                                    <li className="preview-item" style={{background: 'none'}}>
                                        <div className="item">
                                            <label className="ui-label">{asterisk}拒绝原因</label>
                                            <span className="ui-text">
                                                <Input
                                                    placeholder="请输入拒绝原因"
                                                    style={{width: 240}}
                                                    value={comments}
                                                    onChange={e => this.handleInputChange(e, 'comments')}
                                                />
                                            </span>
                                        </div>
                                    </li>
                                }
                                {
                                    approvalStatus == 'DISAGREE' &&
                                    <li className="preview-item" style={{background: 'none'}}>
                                        <div className="item">
                                            <label className="ui-label">{asterisk}审{!contractIsSign ? '批' : '核'}不通过原因</label>
                                            <span className="ui-text">
                                                <Input
                                                    placeholder={`请输入审${!contractIsSign ? '批' : '核'}不通过原因`}
                                                    style={{width: 240}}
                                                    value={comments}
                                                    onChange={e => this.handleInputChange(e, 'comments')}
                                                />
                                            </span>
                                        </div>
                                    </li>
                                }
                            </div>
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )
    }
}

export default ApproveDeliverCode;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/ApproveDeliverCode.js